module.exports = __webpack_public_path__ + "img/fu-wu-3.09dc0752.png";